'use client';

import React, { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { selectedLanguageAtom } from '@/global/store/atoms';
import { NextIntlClientProvider } from 'next-intl';
import en from '../../../../messages/en.json';
import ru from '../../../../messages/ru.json';
import es from '../../../../messages/es.json';
import { TranslationMessages } from '../../i18n';

const messagesMap: Record<string, TranslationMessages> = {
  en: en as TranslationMessages,
  ru: ru as TranslationMessages,
  es: es as TranslationMessages,
};

export default function IntlProvider({ children }: { children: React.ReactNode }) {
  const lang = useAtomValue(selectedLanguageAtom);
  const messages = messagesMap[lang] || messagesMap['en'];
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  useEffect(() => {
    if (mounted) {
      document.documentElement.lang = lang;
    }
  }, [mounted, lang]);

  return (
    <NextIntlClientProvider locale={lang} messages={messages} timeZone="UTC">
      {children}
    </NextIntlClientProvider>
  );
}
